<template>
  <div>
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :title="ruleCustom.pkid > 0 ? '编辑':'新建'"
        width="1200px"
        top="5vh"
        @close="$reset('form')">
      <el-form ref="form" :model="ruleCustom" :rules="ruleValidate" label-width="100px">
        <el-form-item v-if="ruleCustom.pkid>0" label="编号" prop="ruleName">
          <el-input v-model="ruleCustom.ruleName" readonly/>
        </el-form-item>
        <el-row>
          <el-col :span="5">
            <el-form-item label="使用类别" prop="ruleCategory">
              <el-select v-model="ruleCustom.ruleCategory" :disabled="ruleCustom.pkid>0">
                <el-option label="蒂升MCX订单" value="10"/>
                <el-option label="散件导入" value="20"/>
                <el-option label="产品价格" value="30"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="产品名称" prop="productName">
              <div>
                <el-input v-model="ruleCustom.productName" readonly>
                  <el-button slot="append" icon="el-icon-search" :disabled="ruleCustom.pkid>0"
                             @click="$refs.selectMaterial.open()"/>
                </el-input>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="输出类型" prop="ruleType">
              <el-select v-model="ruleCustom.ruleType">
                <el-option label="可见型" :value="10"/>
                <el-option label="字符型" :value="20"/>
                <el-option label="整数型" :value="70"/>
                <el-option label="浮点型" :value="90"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="自定义类型" prop="customType">
              <el-select v-model="ruleCustom.customType">
                <el-option label="客户配置物料" :value="0"/>
                <el-option label="控制柜证书编号" :value="1"/>
                <el-option label="一级参数代码" :value="2"/>
                <el-option label="脉冲数" :value="3"/>
                <el-option label="电气原理图1" :value="4"/>
                <el-option label="电气原理图2" :value="5"/>
                <el-option label="UCMP证书编号" :value="6"/>
                <el-option label="马达额定转速" :value="7"/>
                <el-option label="核对人" :value="8"/>
                <el-option label="审核人" :value="9"/>
                <el-option label="板载化" :value="10"/>
                <el-option label="木箱规格" :value="11"/>
                <el-option label="包装箱" :value="12"/>
                <el-option label="随机文件" :value="13"/>
                <el-option label="ARD" :value="14"/>
                <el-option label="特性值" :value="50"/>
                <el-option label="选配项单选" :value="51"/>
                <el-option label="选配项多选" :value="52"/>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="5">
            <el-form-item label="自定义编号" prop="customerMaterialNo">
              <el-input v-model="ruleCustom.customerMaterialNo"/>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="自定义描述" prop="customerMaterialDesc">
              <el-input v-model="ruleCustom.customerMaterialDesc"/>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="自定义值" prop="customerMaterialValue">
              <el-input v-model="ruleCustom.customerMaterialValue"/>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="数量" prop="qty">
              <el-input v-model="ruleCustom.qty"/>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="单位" prop="unit">
              <el-input v-model="ruleCustom.unit"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="表达式" prop="ruleExpression">
              <el-input type="textarea" rows="5" v-model="ruleCustom.ruleExpression"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="输出表达式" prop="outputExpression">
              <el-input type="textarea" rows="5" v-model="ruleCustom.outputExpression"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注" prop="note">
              <el-input type="textarea" v-model="ruleCustom.note"/>
            </el-form-item>
          </el-col>
        </el-row>
        <product-select ref="selectMaterial" @select="selectProduct"/>
      </el-form>
      <span slot="footer">
      <el-button @click="dialogVisible=false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">
        保存
      </el-button>
    </span>
    </el-dialog>
  </div>
</template>

<script>
  import constant from "@/util/constant";
  import ProductSelect from "../Product/ProductSelect";

  export default {
    name: "RuleCustomEdit",
    components: {ProductSelect},
    data() {
      return {
        dialogVisible: false,
        dataTypes: constant.toSelect(constant.dataType),
        valueTypes: constant.toSelect(constant.valueType),
        contentLoading: false,
        submitLoading: false,
        isCopy: 0,
        ruleCustom: {
          pkid: 0,
          ruleName: "",
          ruleCategory: "10",
          ruleType: 10,
          customType: 0,
          customerMaterialDesc: "",
          customerMaterialNo: "",
          customerMaterialValue: "",
          status: 0,
          qty: 1,
          unit: "PC",
          ruleExpression: "",
          outputExpression: "",
          productName: "",
          productNo: "",
          productId: 0,
          note: "",
        },
        ruleValidate: {
          ruleExpression: [{required: true, message: "表达式不能为空", trigger: "blur"}],
        },
      };
    },
    methods: {
      open: function(id, isCopy) {
        if (isCopy === 1) {
          this.isCopy = 1;
        }
        this.ruleCustom.pkid = id;
        if (id) {
          this.getData(id);
        }
        this.dialogVisible = true;
      },
      getData(id) {
        this.$http
            .get("basic", `ruleCustoms/${id}`)
            .then(resp => {
              console.log(resp);
              if (resp.success) {
                this.ruleCustom = resp.data;
              }
            });
      },
      selectProduct(row) {
        this.ruleCustom.productName = row.materialName;
        this.ruleCustom.productNo = row.materialNO;
        this.ruleCustom.productId = row.materialID;
      },
      handleSubmit() {
        let isAdd = 1;
        if (this.ruleCustom.pkid) {
          isAdd = 0;
        }
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
                .post("basic", `ruleCustoms/save/${isAdd}`, this.ruleCustom)
                .then((resp) => {
                  if (resp.success) {
                    this.submitLoading = false;
                    this.dialogVisible = false;
                    this.$emit("save-success");
                    this.$message.success("保存成功");
                  } else {
                    this.$message.error(resp.message);
                    this.submitLoading = false;
                  }

                })
                .catch(() => {
                  this.submitLoading = false;
                });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
